/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Pay/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ChooseType from './ChooseType/index'
import PayAction from './PayAction/index'
import React from 'react'
import SkipAction from './SkipAction/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Pay({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentSetup/Pay"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Pay.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Pay.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 marginBottom={dtSpaceS}
 text="How do you want to pay for your downpayment?"
/>
<ChooseType
  viewPath={`${viewPath}/ChooseType`}
/>
</div>
<div
  data-testid="Pay.Vertical:2"
  data-view-path={viewPath}
 borderTopRadius={1}
 style={{'--btc-1-luB': dtColorsNeutral200,'--pt-2-luB': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-3-luB': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Pay.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<SkipAction
  viewPath={`${viewPath}/SkipAction`}
/>
<PayAction
  viewPath={`${viewPath}/PayAction`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}